import { defineMessages } from "react-intl";
import padStart from "lodash/padStart";

import ButtonWithCounter from "../Buttons/ButtonWithCounter";
import Tooltip from "../Tooltip/Tooltip";
import { useFormatMessage } from "../Intl/Context";

const CommentButton = ({ disabled = false, disabledMessage = "", ...props }) => {
  const { onClick, count } = props;
  const paddedCount = padStart(count, 2, "0");

  const t = useFormatMessage();
  const title = t(intlMessages.title);
  const totalComment = t(intlMessages.totalComment, {
    count
  });

  return (
    <Tooltip show={disabled} content={disabledMessage}>
      <ButtonWithCounter
        buttonClassName="btn-primary-inverse"
        onClick={onClick}
        label={title}
        iconClassName="icon-contribute"
        iconPosition="after"
        disabled={disabled}
        count={paddedCount}
        size="sm"
        labelComment={totalComment}
        data-comment-button
      />
    </Tooltip>
  );
};

export default CommentButton;

const intlMessages = defineMessages({
  title: {
    id: "comments.button.title",
    defaultMessage: "Commenter"
  },
  totalComment: {
    id: "comments.button.totalComment",
    defaultMessage: `{count, plural,
      =0 {{count} commentaire}
      one {{count} commentaire}
      other {{count} commentaires}
    }`
  }
});
